import AppLayout from "@/layouts/app/AppLayout";

import dashboard from "./dashboard"

export default [
  

  {
    path: "/attendant",
    component: AppLayout,
    meta: {
      middleware: ["auth"],
      roles: ["attendant"],
    },
    children: [
        ...dashboard,
    ],
  },
];
